export const InterchangeEventTypes = {
	DELIVERY: 'DELIVERY',
	PROCESSING: 'PROCESSING',
	OPEN: 'OPEN',
	TRANSIT: 'TRANSIT',
	DELIVERED: 'DELIVERED',
	CLICK: 'CLICK',
	BOUNCE: 'BOUNCE',
	UNKNOWN: 'UNKNOWN'
} as const;

export type InterchangeEventType = (typeof InterchangeEventTypes)[keyof typeof InterchangeEventTypes];

export type InterchangeEvent = {
	event_type: InterchangeEventType;
	timestamp: string;
	channel_endpoint: Record<string, unknown>;
	raw_data: unknown;
	failure: boolean;
	event_subtype?: string | null;
};
